export default __webpack_public_path__ + "static/media/Benton-Sans-Condensed-Medium.926f9c15.otf";